import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const auth = firebase.auth();
const googleProvider = new firebase.auth.GoogleAuthProvider();
const facebookProvider = new firebase.auth.FacebookAuthProvider();

const loginGoogle = () => {
  auth.signInWithPopup(googleProvider);
};

const loginFacebook = () => {
  auth.signInWithPopup(facebookProvider);
};
const signOutUser = (logOutUser) => {
  auth.signOut().then(() => logOutUser());
};

export {
  firestore,
  auth,
  googleProvider,
  facebookProvider,
  loginGoogle,
  loginFacebook,
  signOutUser,
};

export default firebase;
